/** Estilos compartidos por todos los gráficos (coherentes con la aplicación). */

// --- Paletas por tipo de gráfico -------------------------------------------
// Todas mantienen la misma estética (tonos apagados, saturación baja) pero
// cada tipo usa una familia de color distinta para diferenciarse a simple vista.

const PALETTE_BAR = [
  '#0b6775',
  '#30808c',
  '#7ab2ba',
  '#a8d0d6',
  '#d4a373',
  '#4f8f6b',
  '#c48a3d',
  '#8d6f9c',
]

const PALETTE_BAR_HORIZONTAL = [
  '#2d6a4f',
  '#40916c',
  '#52b788',
  '#74c69d',
  '#95d5b2',
  '#b7e4c7',
  '#d8f3dc',
  '#1b4332',
]

const PALETTE_DONUT = [
  '#4a6fa5',
  '#6b8cba',
  '#8facc8',
  '#b4cdd6',
  '#c9a87c',
  '#d4b896',
  '#a89279',
  '#7d8a95',
]

const PALETTE_LINE = [
  '#7b2cbf',
  '#9d4edd',
  '#c77dff',
  '#e0aaff',
  '#706fd3',
  '#474787',
  '#3d3d6b',
  '#2c2c54',
]

const PALETTE_DEFAULT = PALETTE_BAR

/** Mapa chartType → paleta. */
const CHART_THEME = {
  bar: PALETTE_BAR,
  barHorizontal: PALETTE_BAR_HORIZONTAL,
  barStacked: PALETTE_BAR_HORIZONTAL,
  donut: PALETTE_DONUT,
  line: PALETTE_LINE,
  area: PALETTE_LINE,
  ranking: PALETTE_BAR,
  kpi: PALETTE_DEFAULT,
}

/** Devuelve la paleta de colores para un tipo de gráfico dado. */
export function colorsFor(chartType) {
  return CHART_THEME[chartType] || PALETTE_DEFAULT
}

/** Crea una función colorAt(index) ligada a la paleta de un chartType. */
export function makeColorAt(chartType) {
  const palette = colorsFor(chartType)
  return (index) => palette[index % palette.length]
}

// --- Legacy: colorAt sigue disponible para componentes que no conocen el tipo ---
export const CHART_COLORS = PALETTE_BAR
export const colorAt = (index) => CHART_COLORS[index % CHART_COLORS.length]

// --- Estilos compartidos ---------------------------------------------------
export const AXIS_PROPS = {
  tick: { fontSize: 11, fill: '#6c8083' },
  axisLine: false,
  tickLine: false,
}

export const GRID_PROPS = {
  strokeDasharray: '3 3',
  stroke: '#eaf0f0',
  vertical: false,
}

export const TOOLTIP_PROPS = {
  cursor: { fill: 'rgba(11,103,117,0.06)' },
  contentStyle: {
    backgroundColor: '#fff',
    border: '1px solid #e4eaea',
    borderRadius: '10px',
    boxShadow: '0 10px 26px rgba(16,42,48,0.14)',
    fontSize: '12.5px',
    padding: '8px 10px',
  },
  labelStyle: {
    fontSize: '12.5px',
    fontWeight: 600,
    color: '#1d2b2e',
    marginBottom: '4px',
  },
  itemStyle: { fontSize: '12.5px', color: '#1d2b2e', padding: '1px 0' },
}

export const LEGEND_PROPS = {
  wrapperStyle: { fontSize: '12.5px', color: '#6c8083', paddingTop: '8px' },
  iconType: 'circle',
  iconSize: 8,
}
